import zenScroll from 'zenscroll';

const Scrolling = {
	Init() {
		const defaultDuration = 250;

		// Consider using css (scroll-margin-top: 5rem) instead of this
		// MAKE SURE TO TEST FIRST as it can be a little wonky
		// https://css-tricks.com/fixed-headers-and-jump-links-the-solution-is-scroll-margin-top/
		const edgeOffset = 1;
		zenScroll.setup(defaultDuration, edgeOffset);
	}
};

export default Scrolling;
